import styles from '../ProjectsHome.module.css';
import {
    PROJECT_LIFECYCLE_LABEL,
    getLifecycleStatusChipClass,
    getLifecycleStatusTitle,
    normalizeProjectLifecycleStatus,
} from '../projectLifecycle';

/**
 * Project lifecycle indicator for hub project rows (Browse + My projects).
 */
export default function HubProjectStatusChip({ lifecycleStatus }) {
    const status = normalizeProjectLifecycleStatus(lifecycleStatus);
    return (
        <span
            className={getLifecycleStatusChipClass(status, styles)}
            title={getLifecycleStatusTitle(status)}
        >
            {PROJECT_LIFECYCLE_LABEL[status]}
        </span>
    );
}
